import React from "react";
import { StateManagerContext } from "./StateManagerContext";
import { MessageConfigData, PostConfigData } from "../Shared/Party/PartyConfigData";
import {  RenderMessageForFeed } from "./LiveMessageFeed";
import { UIConfig, UIConfigContext } from "./UIConfigContext";
import { Post, PostDisplayProps } from "./Post";
import { VoteCounterDisplay, VoteCounterProps } from "./VoteCounter";
import { Action, ActionButton, ActionButtonProps, CreateAction, EmptyActionData } from "./ActionButton";
import { FanboxStyling } from "./CSSUtilities";

export type UserMessageDisplayProps = {
    userMessages: boolean;

}


const renderMessage = (config: MessageConfigData, userId: string, uiConfig: UIConfig, action?: Action, buttonText?: string): JSX.Element => {

    buttonText = buttonText === undefined ? '' : buttonText;
    const components = Array<JSX.Element>();

    const likesCounterProps: VoteCounterProps = {
        voting: config.voting,
        voteType: 'likes',
        matchExpression: false,
        fontBase: uiConfig.fontBase,
        direction: 'row',
        justify: 'left',
        padding: 5,
        clickHandler: () => { },
        textFirst: false,
        text: '',
    }

    const commentsCounterProps: VoteCounterProps = {
        voting: config.voting,
        voteType: 'comments',
        matchExpression: false,
        fontBase: uiConfig.fontBase,
        direction: 'row',
        justify: 'left',
        padding: 5,
        clickHandler: () => { },
        textFirst: false,
        text: '',
    }
    const pointsCounterProps: VoteCounterProps = {
        voting: config.voting,
        voteType: 'fandompts',
        matchExpression: false,
        fontBase: uiConfig.fontBase,
        direction: 'row',
        justify: 'left',
        padding: 5,
        clickHandler: () => { },
        textFirst: false,
        text: '',
    }

    components.push(<div style={{
        width: uiConfig.width + 'px',
        maxWidth: uiConfig.width + 'px',
        minWidth: uiConfig.width + 'px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        backgroundColor: uiConfig.fanboxColor('darkGray'),
        borderBottom: '2px solid white'
    }}>
        <div style={{ gridColumn: 1 }}><VoteCounterDisplay {...likesCounterProps} /></div>
        <div style={{ gridColumn: 2 }}><VoteCounterDisplay {...commentsCounterProps} /></div>
        <div style={{ gridColumn: 3 }}><VoteCounterDisplay {...pointsCounterProps} /></div>
    </div>)

    const postConfig: PostConfigData = {
        itemId: config.itemId,
        title: config.title ?? '',
        author: '@me',
        layout: 'single-element',
        rotate: 'none',
        messageDisplay: 'none',
        elements: [
            {
                itemId: config.itemId + '_e0',
                layout: config.image !== undefined ? 'primary-left' : 'primary-only',
                primary: {
                    text: config.postText ?? '',
                },
                secondary: config.image !== undefined ? {
                    imageSrc: config.image
                } : undefined,
            }
        ]
    }

    const postDisplay: PostDisplayProps = {
        postHeight: 400,
        messageHeight: 0,
        userId: userId,
        showLikeCommentButtons: false,
    }

    components.push(<Post config={postConfig} display={postDisplay} />)

    if (config.bodyText.length > 0) {
        components.push(<div style={{
            backgroundColor: 'white',
            color: 'black',
            fontSize: uiConfig.fontBase * 1.5,
            fontWeight: 700,
            fontFamily: 'roboto',
            textAlign: 'left',
            width: uiConfig.width + 'px',
            maxWidth: uiConfig.width + 'px',
            minWidth: uiConfig.width + 'px',

        }}>
            {config.bodyText}
        </div>)
    }

    if (action !== undefined) {
        const buttonStyling: FanboxStyling = {
            width: 200,
            height: 66,
            boundary: {
                radius: 75,
                margin: {
                    quadType: 'margin',
                    top: 20,
                    bottom: 0,
                    left: 50,
                    right: 50
                }
            },
            color: {
                background: 'orange',
                foreground: 'white'
            },
            font: {
                size: 24,
                weight: 'bold'
            },

        }
        const bprops: ActionButtonProps = {
            styling: buttonStyling,
            action: action,
            actionData: EmptyActionData,
            text: buttonText,
            prompt: 'center'


        }
        components.push(<ActionButton {...bprops} />)
    }

    return <div style={{
        backgroundColor: uiConfig.fanboxColor('darkGray'),
        width: uiConfig.width + 'px',
        maxWidth: uiConfig.width + 'px',
        minWidth: uiConfig.width + 'px',
        display: 'flex',
        flexDirection: 'column'
    }}>
        {components}
    </div>

}

type UserMessageDisplayState = 'feed' | 'expanded';

export const UserMessageDisplay = ({ userMessages }: UserMessageDisplayProps): React.JSX.Element => {

    const stateManager = React.useContext(StateManagerContext);
    const uiConfig = React.useContext(UIConfigContext);
    const height = uiConfig.height - uiConfig.titleHeight;
    const selectedIndex = React.useRef<number>(0);
    const [displayState, setDisplayState] = React.useState<UserMessageDisplayState>('feed');
    const rcRef = React.useRef<number>(0);
    const [_rc, setRC] = React.useState<number>(0);
    const replies = React.useRef<MessageConfigData[]>([]);

    const feedMessageList = userMessages ? stateManager.userMessages().getForDisplay() : stateManager.userPosts().getForDisplay();

    /* const notifyOnCarouselAction = (index: number) => {
         setSelectedIndex(index);
 
     }
 
     const createCarouselPanels = (): JSX.Element[] => {
         if (userMessages) {
             return [<span></span>]
         }
         else if (messageList.length > 0)
             return messageList.map((row, index) => {
                 return renderMessage(row.message, stateManager.user().fanbox.id, uiConfig);
                 //return renderMessageFeedPanel(row.message, uiConfig.contolBackground, uiConfig.fontBase, stateManager.user().fanbox.id, index + 1000, (_nickname: string) => { });
             })
         else
             return [<span style={{ fontFamily: 'roboto', fontWeight: 500, fontSize: (2 * uiConfig.fontBase) + 'px' }}>You have no replies to this post yet</span>]
     }*/



    /* const carouselProps = React.useRef<CarouselProps>((() => {
         const ret: CarouselProps = {
             display: 1,
             width: uiConfig.width,
             height: 500,
             scrollButtonWidth: 50,
             idPrefix: 'UserMessageDisplayCarousel',
             userControlled: true,
             notifyOnClick: notifyOnCarouselAction,
             panels: createCarouselPanels()
         };
         return ret;
     })()
     );*/

    if (displayState === 'feed') {
        const messageComponents = feedMessageList.map((row, index) => {
            if (userMessages) {
                return renderMessage(row.message, stateManager.user().fanbox.id, uiConfig);
            }
            else {
                const action = userMessages ? undefined : CreateAction("ExpandReplies", [], () => {
                    selectedIndex.current = index;
                    setDisplayState('expanded');
                    const getReplies = async () => {
                        try {
                            const uri = '/api/user/userpostmessages/' + feedMessageList[selectedIndex.current].message.itemId;

                            const response = await fetch(uri, {
                                method: "GET",
                                headers: { "content-type": "application/json" },
                            });
                            const json = await response.json();
                            if (!json.error) { 
                                const replyArray = json.messages as MessageConfigData[];
                                replies.current = replyArray;
                                rcRef.current++;
                                setRC(rcRef.current);
                            }
                        }
                        catch (e) {
                            console.log(e);
                        }
                    }
                    getReplies();
                    return true;

                })
                return renderMessage(row.message, stateManager.user().fanbox.id, uiConfig, action, 'See Replies');
            }
        });



        return <div style={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: uiConfig.width + 'px',
            width: uiConfig.width + 'px',
            maxWidth: uiConfig.width + 'px',
            height: height + 'px',
            maxHeight: height + 'px',
            minHeight: height + 'px',
            position: 'relative',

            backgroundColor: uiConfig.contolBackground

        }}> {messageComponents}
        </div>;
    }
    else {
        const action = CreateAction("Return To Feed", [], () => {
            setDisplayState('feed');
            replies.current = [];
            return true;
        })

        const post = renderMessage(feedMessageList[selectedIndex.current].message, stateManager.user().fanbox.id, uiConfig, action, 'Return to Feed');
        const replyComponents = replies.current.length > 0 ?
            replies.current.map((reply, index) => {
                return RenderMessageForFeed(reply, uiConfig.contolBackground, uiConfig.fontBase, stateManager.user().fanbox.id, index + 10000, uiConfig.showEventOverlay);
            }) : [<span style={{ fontFamily: 'roboto', fontWeight: 500, fontSize: (1.5 * uiConfig.fontBase) + 'px' }}>Replies to this post are loading....</span>];


        return <div style={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: uiConfig.width + 'px',
            width: uiConfig.width + 'px',
            maxWidth: uiConfig.width + 'px',
            height: height + 'px',
            maxHeight: height + 'px',
            minHeight: height + 'px',
            position: 'relative',

            backgroundColor: uiConfig.contolBackground
        }}>

            {post}
            <div style={{
                width: uiConfig.width + 'px',
                minWidth: uiConfig.width + 'px',
                maxWidth: uiConfig.width + 'px',
                height: (height - 200) + 'px',
                maxHeight: (height - 200) + 'px',
                minHeight: (height - 200) + 'px',
                overflow: 'auto'
            }}>
                <div style={{
                    width: uiConfig.width + 'px',
                    minWidth: uiConfig.width + 'px',
                    maxWidth: uiConfig.width + 'px',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    {replyComponents}
                </div>
            </div>
        </div>

    }
    /*
        : <div style={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: uiConfig.width + 'px',
            width: uiConfig.width + 'px',
            maxWidth: uiConfig.width + 'px',
            height: height + 'px',
            maxHeight: height + 'px',
            minHeight: height + 'px',
            position: 'relative',

            backgroundColor: uiConfig.contolBackground
        }}>

            <Carousel {...carouselProps.current} />
            <div style={{
                width: uiConfig.width + 'px',
                minWidth: uiConfig.width + 'px',
                maxWidth: uiConfig.width + 'px',
                height: (height - 200) + 'px',
                maxHeight: (height - 200) + 'px',
                minHeight: (height - 200) + 'px',
                overflow: 'auto'
            }}>
                <div style={{
                    width: uiConfig.width + 'px',
                    minWidth: uiConfig.width + 'px',
                    maxWidth: uiConfig.width + 'px',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    {messageComponents}
                </div>
            </div>
        </div>
        */

}